import * as SynthesisReviewType from './synthesisReviewType'
import useSyntheticReview from './useSyntheticReview'
import MyAccordion from '../../../../../control/accordion/accordion'
import RichTextEditor from '../../../../../control/richTextEditor/richTextEditor'
import { Grid, useTheme, makeStyles } from '@material-ui/core'
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import { FieldArray } from 'react-final-form-arrays'
import TreeCheckbox from '../../../../../control/treeCheckbox/treeCheckbox'
import useTranslate from '../../../../../i18n/useTranslate'
import PageAction from '../pageAction'
import useCheckPermission from '../../../../../utilities/checkPermission'
import useSnackbarAction from '../../../../../stores/snackbar/snackbarAction'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Dialog from '../../../../../control/dialog/dialog'
import constProjectStatus from '../../../../../constants/projectStatus'
import { approveStatusREC1, approveStatusREC2 } from '../../../../../constants/approveStatus'
import DisplayUpdater from '../../../shareUI/displayUpdater/displayUpdater'
import ModeAccordion from '../../../shareUI/modeAccordion/ModeAccordion'
const SynthesisReviewREC2View: React.FC<SynthesisReviewType.SynthesisReviewViewType> = (props) => {
    const {
        initialValues,
        projectData,
        initialComment,
        initialRichTextEditor,
        initialCommentRichTextEditor,
        documentInfoList,
        isShowUpdateDate,
        initialRichRemark,
        handleDirtyChange,
        onClickCancel,
        onSubmitForm,
        configDialog,
        onRefDialog,
        isViewMode,
        isHideDocumentCertificate = false,
        isFlowApproveWithComment = false,
        isEditStampFile,
        clickEditStampFile,
        cancelEditStampFile,
        saveEditStampFile,
    } = props

    const translate = useTranslate()
    const checkPermission = useCheckPermission()
    const snackbarAction = useSnackbarAction()
    const classes = useStyles()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))

    const isAdmin = checkPermission.isUserAdmin()
    // const isShowCommentRemarkList = true
    // const isShowComment = (approveStatus && approveStatus?.id !== 1 && approveStatus?.id !== 8) || !isResearcherView
    const isShowComment = true
    const isSynthesisApprove: boolean =
        projectData?.synthesisApproveStatusInfo?.value === approveStatusREC1.approve ||
        projectData?.synthesisApproveStatusInfo?.value === approveStatusREC2.approve //ผลการพิจารณาเป็น อนุมัติ
    const isDisplayTreeCheckboxSection: boolean =
        !isHideDocumentCertificate && (isFlowApproveWithComment || isSynthesisApprove)
    const isStatusComplete = projectData && projectData?.projectStatusInfo?.value === constProjectStatus.completed
    const isShowCloseProjectButton = isStatusComplete && isAdmin
    // const isDisplayTreeCheckboxSection = true
    // const isEditNextPhase: boolean = projectData?.submitTypeInfo.value === submittedType.editAfterReviewProjectPhase.id
    // const isEditAmaRevising: boolean = projectData?.submitTypeInfo.value === submittedType.editAfterReviewAmaRevising.id
    // const isAmendment: boolean = projectData?.submitTypeInfo.value === submittedType.submittedType4.id
    // const isPhase: boolean = projectData?.submitTypeInfo.value === submittedType.submittedType2.id

    const renderOfficerView = (name: string, index: number) => {
        return (
            <>
                <Grid item xs={12} md={12} lg={12}>
                    <RichTextEditor
                        name={`${name}.commentList`}
                        initialRichTextEditor={initialCommentRichTextEditor[index]}
                        disabled={true}
                        label={
                            initialComment[index].no
                                ? `${initialComment[index].no}. ${initialComment[index].topic}`
                                : translate.get('LABEL.SUGGESTION_NOTICE')
                        }
                        isHideToolbar={true}
                    />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <RichTextEditor
                        name={`${name}.consideration`}
                        initialRichTextEditor={initialRichTextEditor[index]}
                        disabled={isViewMode}
                        isHideToolbar={isViewMode}
                        label={translate.get('LABEL.ETHIC_REVIEW_OUTCOME')}
                        required
                    />
                </Grid>
            </>
        )
    }

    const renderViewComponent = (language: string) => {
        return (
            <TreeCheckbox
                disabled={!isEditStampFile}
                name={'documentCertificate'}
                dataSource={documentInfoList}
                // dataSource={[]}
                labelRadioEN={translate.get('LABEL.ENG')}
                labelRadioTH={translate.get('LABEL.THAI')}
                isLangTH={translate.languageStore.currentLanguage === translate.languageKey.th}
            />
        )
    }

    const renderEditComponent = (language: string) => {
        return (
            <TreeCheckbox
                disabled={!isEditStampFile}
                name={'documentCertificate'}
                dataSource={documentInfoList}
                // dataSource={[]}
                labelRadioEN={translate.get('LABEL.ENG')}
                labelRadioTH={translate.get('LABEL.THAI')}
                isLangTH={translate.languageStore.currentLanguage === translate.languageKey.th}
            />
        )
    }

    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{ ...initialValues, commentDirector: initialComment }}
            keepDirtyOnReinitialize={true}
            mutators={{
                ...arrayMutators,
            }}
        >
            {(props) => {
                // if (formRenderPropsRef) {
                //     formRenderPropsRef.current = props
                // }
                const { form, handleSubmit, dirty, invalid, errors, values } = props

                return (
                    <>
                        <Grid container spacing={2}>
                            {!isFlowApproveWithComment && (
                                <Grid item xs={12}>
                                    <MyAccordion title={translate.get('LABEL.RESOLUTION')}>
                                        <Grid container item justify="flex-start" spacing={2}>
                                            <Grid item xs={12} md={12} lg={12}>
                                                <Grid item xs={12} md={12} lg={12}>
                                                    <RichTextEditor
                                                        name="remark"
                                                        initialRichTextEditor={initialRichRemark}
                                                        disabled={isViewMode}
                                                        isHideToolbar={isViewMode}
                                                        // label={translate.get('LABEL.ETHIC_REVIEW_OUTCOME')}
                                                        maxLength={2000}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </MyAccordion>
                                </Grid>
                            )}
                            {!isFlowApproveWithComment && (
                                <Grid item xs={12}>
                                    <MyAccordion title={translate.get('LABEL.NOTIFY_REVIEW_OUTCOME')}>
                                        <Grid container item justify="flex-start" spacing={2}>
                                            {isShowComment && (
                                                <FieldArray name="commentDirector">
                                                    {({ fields }) => {
                                                        return fields?.map((name, index) =>
                                                            renderOfficerView(name, index),
                                                        )
                                                    }}
                                                </FieldArray>
                                            )}
                                        </Grid>
                                    </MyAccordion>
                                </Grid>
                            )}
                            {isDisplayTreeCheckboxSection && (
                                <Grid item xs={12}>
                                    <ModeAccordion
                                        title={translate.get('LABEL.DOC_TO_BE_CERTIFIED')}
                                        renderViewComponent={() => renderViewComponent('TH')}
                                        renderEditComponent={() => renderEditComponent('TH')}
                                        isViewMode={isViewMode}
                                        onClickEdit={() => clickEditStampFile()}
                                        onCancel={() => cancelEditStampFile()}
                                        onConfirm={() => saveEditStampFile()}
                                    ></ModeAccordion>
                                </Grid>
                            )}

                            {isShowUpdateDate && <DisplayUpdater />}

                            {!isViewMode && (
                                <Grid item xs={12}>
                                    <PageAction
                                        onClickClose={() => {
                                            onClickCancel(dirty)
                                        }}
                                        onClickSave={() => {
                                            form.change('submitType', 'save')
                                            handleSubmit()
                                            invalid &&
                                                errors &&
                                                snackbarAction.openSnackbar({
                                                    message: translate.get('MESSAGE.M012'),
                                                    type: 'error',
                                                })
                                        }}
                                        onClickSaveDraft={() => {
                                            form.change('submitType', 'draft')
                                            handleSubmit()
                                        }}
                                    />
                                </Grid>
                            )}
                            {/* {!isFlowApproveWithComment && (
                                <Grid item xs={12}>
                                    <MyAccordion title={translate.get('LABEL.REMARK')}>
                                        <Grid container item justify="flex-start" spacing={2}>
                                            {!isResearcherView ? (
                                                <Grid item xs={12} md={12} lg={12}>
                                                    <Grid item xs={12} md={12} lg={12}>
                                                        <MyTextfield
                                                            name="commentRemarkList"
                                                            materialInputProps={{
                                                                disabled: true,
                                                                label: '',
                                                                size: 'small',
                                                                rows: 5,
                                                                multiline: true,
                                                            }}
                                                            // required
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={12} lg={12}>
                                                        <RichTextEditor
                                                            name="remark"
                                                            initialRichTextEditor={initialRichRemark}
                                                            disabled={isViewMode}
                                                            isHideToolbar={isViewMode}
                                                            // label={translate.get('LABEL.ETHIC_REVIEW_OUTCOME')}
                                                            maxLength={2000}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            ) : (
                                                <Grid item xs={12} md={12} lg={12}>
                                                    <RichTextEditor
                                                        name="remark"
                                                        initialRichTextEditor={initialRichRemark}
                                                        disabled={true} //{isViewMode}
                                                        isHideToolbar={isViewMode}
                                                        // label={translate.get('LABEL.ETHIC_REVIEW_OUTCOME')}
                                                        maxLength={2000}
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                    </MyAccordion>
                                </Grid>
                            )} */}
                        </Grid>

                        <Dialog onRef={onRefDialog} {...configDialog} />
                        <FormSpy
                            subscription={{ dirty: true, values: true }}
                            onChange={(formState) => handleDirtyChange(formState, form)}
                        />
                    </>
                )
            }}
        </Form>
    )
}

const SynthesisReviewREC2: React.FC<SynthesisReviewType.SynthesisReviewType> = (props) => {
    const useSyntheticReviewModel = useSyntheticReview(props)
    return <SynthesisReviewREC2View {...useSyntheticReviewModel} {...props} />
}
const useStyles = makeStyles((theme) => ({
    spacingButton: {
        marginBottom: '10px',
    },
    paper: {
        width: '100%',
        height: 128,
        padding: 20,
    },
    titleFont: {
        color: '#BDBDBD',
    },
    contentFont: {
        fontWeight: 'bold',
    },
}))

export default SynthesisReviewREC2
